import { render } from "./BookCoverRecognition.vue?vue&type=template&id=26ae4840&scoped=true"
import script from "./BookCoverRecognition.vue?vue&type=script&lang=js"
export * from "./BookCoverRecognition.vue?vue&type=script&lang=js"

import "./BookCoverRecognition.vue?vue&type=style&index=0&id=26ae4840&scoped=true&lang=css"

import exportComponent from "E:\\学习资料\\项目\\Vue-Springboot-Library-main\\vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26ae4840"]])

export default __exports__